module.exports = __webpack_public_path__ + "static/img/footer_people.ff3bcc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer_people.png
// module id = 9yZ1
// module chunks = 1